
export default {
  data() {
    return {
      showBackToTop: false,
      lastButtonRect: null // 保存按钮的最新边界矩形数据
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const adsElements = document.querySelectorAll(".adsbygoogle");
      const backToTopElement = this.$refs.backToTopElement;

      if (backToTopElement && backToTopElement.getBoundingClientRect().height !== 0) {
        this.lastButtonRect = backToTopElement.getBoundingClientRect();
      }

      if (!this.lastButtonRect || !adsElements) {
        this.showBackToTop = window.scrollY > 300;
        return;
      }

      // 检查按钮是否与任何广告元素重叠
      let isOverlappingAnyAd = false;
      for (const adsElement of adsElements) {
        const adsRect = adsElement.getBoundingClientRect();
        // 有交集且广告元素高度不为0
        if (this.isOverlapping(this.lastButtonRect, adsRect) && adsRect.height !== 0) {
          isOverlappingAnyAd = true;
          break;
        }
      }

      this.showBackToTop = window.pageYOffset > 300 && !isOverlappingAnyAd;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    /* 判断按钮是否与ads重叠 */
    isOverlapping(rect1, rect2) {
      return (
        rect1.bottom > rect2.top &&
        rect1.top < rect2.bottom &&
        rect1.left < rect2.right &&
        rect1.right > rect2.left
      );
    }
  }
};
